import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorStoreAccountView = () => {
  const { t } = useTranslation()

  const storeAccountView = useCallback(
    (body, callback, loading) => {
      const payload = {
        ...body,
        account_uid: '',
        source: 'CMS',
      }
      ApiService.jsonRequest('/store-account/view', payload, response => {
        if (response.status_code === 200) {
          callback(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 1500,
          })
        }
        loading(false)
      })
    },
    [t],
  )

  return { storeAccountView }
}

export default InteractorStoreAccountView
